import * as React from "react";
import {Article} from "../../model/Article";
import '../magazine-widget.css';

interface MagazineArticleProps {
    article: Article,
}


/**
 * Text Input Element
 */
export class MagazineArticle extends React.Component<MagazineArticleProps, {}> {

    render() {
        return <a className="clearfix magazine-link" href={this.props.article.url} target={"_blank"}>
            <article className="magazine-article">
                <img alt={this.props.article.title} className="magazine-image" src={this.props.article.imageUrl}/>
                <div className="magazine-category">{this.props.article.category}</div>
                <h2 className="magazine-headline">{this.props.article.title}</h2>
                <p className="magazine-teaser">{this.props.article.teaser}</p>
            </article>
        </a>;
    }
}
